var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.416%",
    y1: "41.829%",
    x2: "134.123%",
    y2: "74.854%",
    id: "ain3h7w38a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033898",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.226%",
    y1: "22.619%",
    x2: "26.538%",
    y2: "76.499%",
    id: "aprjqdj8gb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "79.507%",
    x2: "87.442%",
    y2: "35.148%",
    id: "9hbnkrr8mc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26 14.745c2.22.66 7.844-3.431 7.844-3.431S8.535 9.754 3.967 9.57C-.602 9.388.165 14.745.165 14.745s2.875-.66 5.095 0z",
    fill: "url(#ain3h7w38a)",
    transform: "translate(8 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.104 17.15S1.038 19.058.27 25.668c0 0-2.515-12.693 12.834-14.234v5.718z",
    fill: "url(#aprjqdj8gb)",
    transform: "translate(8 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667 6.012S2.905 6.263.137 14.817c0 0-2.854-13.849 17.53-14.817v6.012z",
    fill: "url(#9hbnkrr8mc)",
    transform: "translate(8 4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.defb78edb1c9272160a3a3fa1e192957.svg";
export { ForwardRef as ReactComponent };